import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { BiometricActivatorPageRoutingModule } from './biometric-activator-routing.module';
import { BiometricActivator } from './biometric-activator.page';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    IonicModule,
    BiometricActivatorPageRoutingModule
  ],
  declarations: [BiometricActivator]
})
export class BiometricActivatorModule {}